import { last } from 'lodash';
import { useMediaQuery } from 'usehooks-ts';
import { useContext, useEffect, useState } from 'react';
import { Toast, ToastBody, ToastContainer } from 'react-bootstrap';

import {
  NotificationContent,
  NotificationContext
} from '../../contexts/notification';
import { uuid } from '../../types/common-helper';

const NotificationAlert = () => {
  const [notification, setNotification] = useContext(NotificationContext);
  const [uniqueId, setUniqueId] = useState(uuid());

  const isSmallDevice = useMediaQuery('(max-width:767px)');

  const handleOnClose = (data: NotificationContent): void => {
    setNotification({
      ...notification,
      content: notification.content.map((notif) => ({ ...notif, isHide: true }))
    });

    if (data && data.onCloseCallback) data.onCloseCallback();
  };

  const latestNotif = last(notification.content);

  useEffect(() => {
    setUniqueId(uuid());
  }, [latestNotif]);

  if (!latestNotif) return <></>;

  return (
    <ToastContainer
      className={'d-flex align-items-center p-2'}
      position={'top-center'}
      style={{
        zIndex: 9999,
        height: isSmallDevice ? '5rem' : '6rem'
      }}>
      <Toast
        autohide
        delay={7000}
        key={uniqueId}
        onClose={() => handleOnClose(latestNotif)}
        show={!latestNotif.isHide}
        className={`k-button--gradient py-1`}
        style={{ borderRadius: '10px' }}>
        <ToastBody
          className={
            'd-flex justify-content-between align-items-center text-white p-2 gap-2'
          }>
          <span
            className={'material-symbols-outlined'}
            style={{ fontSize: '32px' }}
            color={'white'}>
            {latestNotif.icon}
          </span>

          <div>
            <span style={{ fontSize: '12px' }}>{latestNotif.message}</span>
          </div>

          <div className={'d-flex align-items-center'}>
            <span
              role={'button'}
              className={'material-symbols-outlined text-dark fw-bold'}
              onClick={() => handleOnClose(latestNotif)}>
              close
            </span>
          </div>
        </ToastBody>
      </Toast>
    </ToastContainer>
  );
};

export default NotificationAlert;
